import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热播精选</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            全网最热电视剧和电影一网打尽，总有一部是你的菜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, index) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.08}s both` }}
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-primary-500 text-white text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-accent-600 font-medium">{item.category}</span>
                <h3 className="font-heading text-lg text-foreground-950 mt-1 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}